import { Component, EventEmitter, Output } from '@angular/core';
import { ToolbarType } from '../../../services/lineup-service';

@Component({
  selector: 'toolbar-field',
  templateUrl: 'toolbar-field.html'
})
export class ToolbarFieldComponent {
  @Output() onTypeSelected = new EventEmitter<ToolbarType>();

  onCloseClick() {
    this.onTypeSelected.emit(ToolbarType.main)
  }
}





// WEBPACK FOOTER //
// /src/pages/apps/lineup/components/toolbar/toolbar-field/toolbar-field.ts